import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

//api
const getCategoryapi = async () => {
    try {
        const res = await axiosInstance.get(`/category/featured`)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const postCategory = async (form, id) => {
    try {
        const {
            name, description, isFeatured, images
        } = form;

        const formData = new FormData();
        // Required Field
        formData.append("name", name);
        formData.append("isFeatured", isFeatured);
        formData.append("description", description);

        if (images) {
            if (typeof images === "string") {
                formData.append("images", images);
            }
            else {
                formData.append("pictures", images);
            }
        }

        if (id) {
            formData.append("id", id);
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/category`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        console.log("category", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const getCategoryByIdFunction = async (id) => {
    try {

        const params = new URLSearchParams();
        params.append('id', id);

        const res = await axiosInstance.get(`/category/id?${params.toString()}`)
        toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getAllCategoryFunction = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/category?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const deleteCategory = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
            return
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/category/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        // return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const dowloadcategory = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/category/dowload?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            responseType: "arraybuffer",
        })

        const blob = new Blob([res.data], { type: "application/pdf" });


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const now = new Date();
        const timeString = `${now.getHours()}_${now.getMinutes()}_${now.getSeconds()}`;
        link.download = `category-details_${timeString}.pdf`;


        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        window.URL.revokeObjectURL(link.href);

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export {
    postCategory,
    getCategoryapi,
    deleteCategory,
    dowloadcategory,
    getAllCategoryFunction,
    getCategoryByIdFunction,
}
